import {
  fetchFileFromRemote,
  getDuration,
  getReminderTimeArray,
  getRemindTimeFromEventData,
  calculateDate,
  getFrequencyOptions,
  defaultFrequencyOption,
} from '../../common/helpers'

export const mapFormDataToClassDto = async (formValues, advancedTicketingEnabled) => {
  const image = formValues.image.url
    ? await fetchFileFromRemote(formValues.image.url)
    : formValues.image

  const formData = {
    event: false,
    // Class details
    buildingId: formValues.building.id,
    type: formValues.type.text,
    name: formValues.name,
    trainerId: formValues.organizer.id,
    description: formValues.description,
    image: image,

    // Date/Time
    place: formValues.place,
    date: calculateDate(formValues.timeStart, formValues.building.timezone),
    duration: getDuration(formValues.timeStart, formValues.timeEnd),
    schedulerType:
      formValues.frequency && formValues.frequency !== 'none' ? formValues.frequency : null,

    // Tickets
    capacity: formValues.capacity,
    tickets: formValues.tickets.map((ticket) => ({
      ...(ticket.id ? { id: ticket.id } : {}),
      name: ticket.name,
      description: ticket.description,
      price: parseInt(ticket.price),
      ...(advancedTicketingEnabled && { inactive: ticket.inactive }),
    })),
    // Advanced - rsvp
    hideAttendees: formValues.hideAttendees,

    // Advanced  - communication
    remindRsvpBeforeHours: formValues.remindRsvp
      ? getReminderTimeArray(formValues.remindRsvpValues)
      : [],
    remindAllBeforeHours: formValues.remindAll
      ? getReminderTimeArray(formValues.remindAllValues)
      : [],
    createEventSurvey: formValues.askForPostEventReview,
    socialLinkService: formValues.socialLinkService || null,
    ...(formValues.positiveReview && formValues.replyTo ? { replyTo: formValues.replyTo } : {}),
    // TODO - to delete once ticket step is done
    cost: 0,
  }

  return formData
}

export const mapClassDtoToFormData = ({
  eventData,
  buildingOptions,
  eventTypeOptions,
  trainerOptions,
}) => {
  const formData = {
    building: buildingOptions.find((option) => option.id === eventData.buildingId.id),
    type: eventTypeOptions.find((option) => option.id === eventData.type.id),
    name: eventData.name,
    organizer: trainerOptions.find((option) => option.id === eventData.trainerId?.id),
    description: eventData.description,
    image: eventData.image,
    // Date/Time
    place: eventData.place,
    timeStart: eventData.start,
    timeEnd: eventData.end,
    frequency:
      getFrequencyOptions().find((option) => option.value === eventData.schedulerType)?.value ||
      defaultFrequencyOption,
    // Tickets
    capacity: eventData.capacity,
    tickets: eventData.tickets,
    // Advanced - rsvp
    hideAttendees: eventData.hideAttendees,
    // Advanced - Communication
    automatedRemindersToggle:
      !!eventData.remindAllBeforeHours.length || !!eventData.remindRsvpBeforeHours.length,
    remindRsvp: !!eventData.remindRsvpBeforeHours.length,
    remindRsvpValues: eventData.remindRsvpBeforeHours
      ? getRemindTimeFromEventData(eventData.remindRsvpBeforeHours)
      : [''],
    remindAll: !!eventData.remindAllBeforeHours.length,
    remindAllValues: eventData.remindAllBeforeHours
      ? getRemindTimeFromEventData(eventData.remindAllBeforeHours)
      : [''],
    askForPostEventReview: !!eventData.createEventSurvey,
    positiveReview: !!eventData.socialLinkService,
    socialLinkService: eventData.socialLinkService || '',
    replyTo: eventData.replyTo || '',
  }
  return formData
}
